/* ue-variant-fast.js — 옵션을 고른 **즉시** 변형을 확정한다 (2026-09-28 의장 지시)

   ── 무엇이 문제였나 ─────────────────────────────────────────────────────────
   포컬 13 의 `variant-picker` 는 옵션을 고를 때마다 **서버에 제품 구간을 통째로 다시 달라고** 한다
   (`/products/○○?option_values=…&section_id=…`). 그 답이 오기 전까지 `[name=id]` 는 **옛 변형 그대로**다.
   그 사이에 손님이 「담기」를 누르면 **방금 고른 것이 아닌 것이 담긴다.**

   라이브(포컬 12)는 다르다. 화면을 열 때 `/products/○○.js` 를 **한 번** 받아 두고
   그 뒤로는 기계 안에서 찾는다 — 그래서 즉시 확정된다.

   ── 무엇을 하나 ────────────────────────────────────────────────────────────
   라이브와 같은 방식을 얹는다. 옵션이 바뀌면 우리가 먼저 변형을 찾아 `[name=id]` 를 확정한다.
   테마의 화면 갱신(사진·가격·재고 글)은 **제 속도로 뒤따라온다.** 둘은 같은 값이라 부딪치지 않는다.
   덤으로, 테마가 「한가할 때(최대 2초 뒤)」 시작하던 미리받기를 **화면에 뜨는 즉시** 깨운다.

   ── 지킨 것 ────────────────────────────────────────────────────────────────
   · 테마 파일을 고치지 않는다. 포컬을 업데이트해도 이 파일은 그대로 산다
   · **품절 변형에는 손대지 않는다** — 우리가 앞서 확정했다가 담기가 거절당하면 더 나쁘다.
     그런 조합은 테마가 알아서 고르게 둔다
   · 값을 못 읽은 옵션이 하나라도 있으면 **아무것도 하지 않는다.** 틀린 확정보다 늦은 확정이 낫다
   · `variant:change` 를 우리가 띄우지 않는다. 테마 것만 남긴다 — 두 번 띄우면 구간이 두 번 그려진다
     (0-27절: 감시가 자기가 그린 것을 다시 잡는 사고를 한 번 냈다)

   ⚠ 옵션 입력칸의 value 는 **값 이름이 아니라 값 번호(option value id)** 다 (포컬 13).
     그래서 화면에서 번호 → 이름을 읽어 `/products/○○.js` 의 `variant.options` 와 맞춘다. */

(function () {
  'use strict';

  var 받은것 = Object.create(null);   /* 핸들 -> 약속(제품 자료) */

  function 뿌리() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) { return Shopify.routes.root; }
    } catch (e) { /* 무시 */ }
    return '/';
  }

  function 제품자료(핸들) {
    if (!받은것[핸들]) {
      받은것[핸들] = fetch(뿌리() + 'products/' + encodeURIComponent(핸들) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return 받은것[핸들];
  }

  function 벗기기(글) { return String(글 == null ? '' : 글).replace(/\s+/g, ' ').trim(); }

  function 감싸기(값) {
    /* CSS.escape 가 없는 브라우저도 있다 */
    if (window.CSS && CSS.escape) { return CSS.escape(값); }
    return String(값).replace(/["\\]/g, '\\$&');
  }

  /* 입력칸 하나가 가리키는 **값의 이름**을 화면에서 읽는다.
     네 가지 생김새가 있다 — 드롭다운 · 사진 스와치 · 색 스와치 · 글상자 스와치 */
  function 값이름(입력) {
    var 값 = 입력.value;
    if (!값) { return null; }

    var 칸 = 입력.closest ? 입력.closest('.product-form__option-selector') : null;
    if (칸) {
      /* 드롭다운 — 감춰진 입력칸 하나 + role=option 단추들 */
      var 단추 = 칸.querySelector('[role="option"][value="' + 감싸기(값) + '"]');
      if (단추) { return 벗기기(단추.textContent); }
    }

    /* 사진 스와치 — 입력칸에 aria-label 로 이름이 붙어 있다 */
    var 라벨글 = 입력.getAttribute('aria-label');
    if (라벨글) { return 벗기기(라벨글); }

    /* 색·글상자 스와치 — 짝지어진 label 안에 이름이 있다 */
    if (입력.id) {
      var 라벨 = document.querySelector('label[for="' + 감싸기(입력.id) + '"]');
      if (라벨) {
        var 숨은 = 라벨.querySelector('.visually-hidden');
        return 벗기기(숨은 ? 숨은.textContent : 라벨.textContent);
      }
    }
    return null;
  }

  /* 지금 고른 값들을 **옵션 차례대로** 이름으로 돌려준다.
     테마의 getActiveOptionValues 와 같은 규칙이되, 번호가 아니라 이름을 낸다 */
  function 지금값들(폼) {
    var 칸들 = [];
    for (var i = 0; i < 폼.elements.length; i++) {
      var e = 폼.elements[i];
      if (e.matches && e.matches('input[data-option-position]:checked, input[data-option-position][type="hidden"]')) {
        칸들.push(e);
      }
    }
    칸들.sort(function (a, b) {
      return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
    });
    return 칸들.map(값이름);
  }

  function 맞는변형(자료, 이름들) {
    if (!자료 || !자료.variants || !이름들.length) { return null; }
    for (var i = 0; i < 자료.variants.length; i++) {
      var v = 자료.variants[i], 맞다 = true;
      for (var j = 0; j < 이름들.length; j++) {
        if (벗기기(v.options[j]) !== 벗기기(이름들[j])) { 맞다 = false; break; }
      }
      if (맞다) { return v; }
    }
    return null;
  }

  function 아이디칸(폼) {
    try { return 폼.elements.namedItem('id'); } catch (e) { return null; }
  }

  /* ── 옵션이 바뀌면 즉시 확정한다 ─────────────────────────────────────────── */
  document.addEventListener('change', function (e) {
    var 입력 = e.target;
    if (!입력 || !입력.matches || !입력.matches('input[data-option-position]')) { return; }

    var 고르개 = 입력.closest ? 입력.closest('variant-picker') : null;
    if (!고르개) { return; }

    var 핸들 = 고르개.getAttribute('handle');
    var 폼이름 = 고르개.getAttribute('form-id');
    if (!핸들 || !폼이름) { return; }

    var 폼 = document.forms[폼이름];
    if (!폼) { return; }

    var 이름들 = 지금값들(폼);
    if (!이름들.length) { return; }
    for (var i = 0; i < 이름들.length; i++) {
      if (이름들[i] == null) { return; }          /* 하나라도 못 읽으면 손대지 않는다 */
    }

    제품자료(핸들).then(function (자료) {
      var v = 맞는변형(자료, 이름들);
      if (!v) { return; }
      if (v.available === false) { return; }      /* 품절 조합은 테마가 고르게 둔다 */

      var 칸 = 아이디칸(폼);
      if (!칸 || !('value' in 칸)) { return; }
      if (String(칸.value) === String(v.id)) { return; }

      칸.value = String(v.id);
      칸.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }, true);

  /* ── 테마의 미리받기를 화면에 뜨는 즉시 깨운다 ──────────────────────────────
     테마는 `requestIdleCallback(…, {timeout: 2000})` 으로 미룬다. 이 몰은 앱이 많아
     「한가한 때」가 늦게 오고, 그 전에 누르면 통신을 그대로 기다린다.
     테마가 이미 가진 길(라벨 위에 마우스를 올리면 미리 받는다)을 그대로 두드린다. */
  function 미리깨우기() {
    var 고르개들 = document.querySelectorAll('variant-picker');
    for (var i = 0; i < 고르개들.length; i++) {
      var 라벨들 = 고르개들[i].querySelectorAll('input[data-option-position]:not(:checked) + label');
      for (var j = 0; j < 라벨들.length; j++) {
        try {
          라벨들[j].dispatchEvent(new PointerEvent('pointerenter', { bubbles: false, cancelable: false }));
        } catch (err) { /* PointerEvent 가 없는 브라우저는 그냥 지나간다 */ }
      }
    }
  }

  function 제품자료_미리() {
    var 고르개 = document.querySelector('variant-picker[handle]');
    if (고르개) { 제품자료(고르개.getAttribute('handle')); }
  }

  function 시작() {
    제품자료_미리();
    /* 테마의 variant-picker 가 깨어난 뒤라야 두드릴 곳이 있다 */
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-picker').then(function () {
        window.setTimeout(미리깨우기, 0);
      }).catch(function () { window.setTimeout(미리깨우기, 300); });
    } else {
      window.setTimeout(미리깨우기, 300);
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', 시작); }
  else { 시작(); }
  document.addEventListener('shopify:section:load', 시작);
})();
